<template>
  <div class="about">
    <iframe src="https://anglersleaderboard.com" loading="eager" width="100%" style="border:none;height: 100vh;"></iframe>
  </div>
</template>
